module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v("- Các bài chia sẻ (icon thành tích, lý thuyết, video) của user về trang của mình.")]), _c('p', [_vm._v("- Các bài chia sẻ của friend và bạn đồng hành.")]), _c('p', [_vm._v("- Kết quả cuộc thi chung thuộc môn học thế mạnh của user.")]), _c('p', [_vm._v("- Các bài chia sẻ của người mà user đã chọn đang theo dõi.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a509b0e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/Activity.vue
// module id = 1575
// module chunks = 0